import { routerInstance } from 'boot/router-access';

/**
 * Сервис для навигации в Quasar-приложении.
 * Использует useRouter() вместо прямого импорта router.
 */
export const navigateTo = (path) => {
  routerInstance.push(path)
}
